import {
	EndFilter,
	StartFilter,
} from "@/pages/delays/shared/components/StartEndFilter";
import { TextFieldSearchFilter } from "@/shared/components/TextFieldSearchFilter";
import Grid2 from "@mui/material/Grid2";
import { Moment } from "moment";
import { StatusFilter } from "./StatusFilter";

type Props = {
	setStartDate: (startDate: Moment) => void;
	setEndDate: (endDate: Moment) => void;
	setFilterValue: (value: string) => void;
	setStatusValue: (value: "All" | "A" | "O" | "S") => void;
	startDate: Moment;
	endDate: Moment;
	filterValue: string;
	statusValue: string;
};

export const Filters = ({
	setStartDate,
	setEndDate,
	setFilterValue,
	setStatusValue,
	startDate,
	endDate,
	filterValue,
	statusValue,
}: Props) => {
	return (
		<Grid2
			container
			size={{ xs: 12, md: 12 }}
			justifyContent="center"
			alignItems="center"
			spacing={2}
		>
			<Grid2
				size={{
					lg: 6,
					md: 6,
					xs: 6,
				}}
				style={{ marginBottom: 5 }}
			>
				<TextFieldSearchFilter
					value={filterValue}
					onChange={(value) => setFilterValue(value)}
				/>
			</Grid2>
			<Grid2
				size={{
					lg: 2,
					md: 6,
					xs: 6,
				}}
			>
				<StartFilter
					value={startDate}
					onChange={(newDate: Moment | null) => {
						if (newDate) setStartDate(newDate);
					}}
				/>
			</Grid2>
			<Grid2
				size={{
					lg: 2,
					md: 6,
					xs: 6,
				}}
			>
				<EndFilter
					value={endDate}
					onChange={(newDate: Moment | null) => {
						if (newDate) setEndDate(newDate);
					}}
				/>
			</Grid2>
			<Grid2
				size={{
					lg: 2,
					md: 6,
					xs: 6,
				}}
			>
				<StatusFilter value={statusValue} onChange={setStatusValue} />
			</Grid2>
		</Grid2>
	);
};
